import React from 'react'
import profile from '../../../../assets/images/default-placeholder.png'
import './index.css'
import { useLocation, useNavigate } from 'react-router-dom'
const Usercreated: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { state } = location
    const { firstName, lastName, image } = state
    return (
        <div>
            <div className="bg-white h-[100vh] flex items-center card-box card-box-landing">
                <div className="card-box-center">
                    <div className="col-12 grid-upload">
                        <div className="upload-box mb-4">
                            <img
                                src={image.data ? image?.data : profile}
                                alt="Logo"
                                className="icon-profile"
                            />
                        </div>
                        <div className="upload-box-center d-flex justify-content-center">
                            <h3>Account Created Successfully</h3>
                            <h4 className="account-profile">{`${firstName} ${lastName}`}</h4>
                        </div>

                        <div className="custom-btn-design custom-btn-design-block button-block mt-5 mb-5">
                            <a
                                className="button button-primary me-3"
                                onClick={() => navigate('/users/add-new')}
                            >
                                CREATE ANOTHER
                            </a>
                            <a
                                className="button button-outline"
                                onClick={() => navigate('/users')}
                            >
                                CLOSE
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Usercreated
